<template>
  <div>
    <lida-table
      class="mt-1"
      :propscolumns="column"
      :data="items"
      :sortStatus="false"
      :LeaveSpace="!sortSate"
      :propsPageSize="20"
    >
      <template v-slot:headerSelect>
        <Button
          type="primary"
          to="electronic-games"
        >返回</Button>
        <Button
          type="info"
          class="mx-2"
          v-if="GameSwitchPermission"
          @click="refreshElectronicGameList"
          :loading="refreshLoading"
        >更新外站游戏</Button>
        <Button
          type="warning"
          class
          v-if="GameSwitchPermission"
          @click="sortSate = !sortSate"
        >修改</Button>
        <span v-show="sortSate">
          <Button
            class="setBackBtn"
            type="primary"
            @click="sortSate = !sortSate"
            :disabled="sortSateLoading"
          >取消</Button>
          <Button
            class="setBackBtn"
            type="error"
            @click="modifySiteGameTrigger"
            :loading="sortSateLoading"
          >储存</Button>
        </span>
      </template>
    </lida-table>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import idopColor from '@/mixins/idopColor'
import triggerColumns from '@/mixins/triggerColumns'
export default {
  name: 'electronic-games-makers-list',
  mixins: [idopColor, triggerColumns],
  data () {
    return {
      items: [],
      refreshLoading: false,
      sortSate: false,
      openSate: false,
      sortSateLoading: false,
      columnObject: {
        linkgameid: {
          title: '游戏编号',
          key: 'linkgameid',
          align: 'center',
          className: "infor-column",
        },
        gamecode: {
          title: '游戏代碼',
          key: 'gamecode',
          align: 'center',
        },
        gamehall: {
          title: '游戏商',
          key: 'gamehall',
          align: 'center',
        },
        gametype: {
          title: '游戏类型',
          key: 'gametype',
          align: 'center',
        },
        gamename: {
          title: '游戏名称',
          key: 'gamename',
          align: 'center',
        },
        maintainText: {
          title: '维护状态',
          key: 'maintainText',
          align: 'center',
        },
        updatetime: {
          title: '更新时间',
          key: 'updatetime',
          align: 'center',
        },
        idopText: {
          key: 'statusText',
          align: 'center',
          minWidth: 40,
          renderHeader: (this.triggerHeaderIdop),
          render: (h, params) => this.triggerIdop(h, params, 'linkgameid')
        },
      }
    };
  },
  created () {
    this.getElectronicGameList();
  },
  computed: {
    ...mapGetters(['getmember', 'getpermission']),
    column () {
      let columns = Object.assign({}, this.columnObject)
      if (this.sortSate == true) {
        delete columns.gamespid;
        return columns
      } else {
        delete columns.selection;
        return columns
      }
    },
    GameSwitchPermission () {
      return this.getpermission.gameswitch[3] == '1'
    }
  },
  watch: {
    sortSate (val) {
      if (val) return
      this.items = this.items.map(it => {
        it.idop = it.defaultidop
        return it
      })
    }
  },
  methods: {
    async getElectronicGameList () {
      const makerid = this.$route.query.makerid
      if (!makerid) return
      try {
        const res = await this.$axios.cq9.getElectronicGameList(makerid)
        if ('status' in res && res.status === 0) return
        this.items = res.map(it => {
          const nameset = it.nameset ? it.nameset.find(it => it.lang.toLowerCase() == 'zh-cn') : null
          it.gamename = nameset ? nameset.name : null
          it.maintainText = it.maintain == 0 ? '正常中' : '维护中'
          it.idopText = it.idop ? '开启' : '关闭'
          it.defaultidop = it.idop
          return it
        })
      } catch (error) {
        console.log(error);
        this.$Message.error('网路异常');
      }
    },
    async refreshElectronicGameList () {
      this.refreshLoading = true;
      const loadingTime = () => setTimeout(() => this.refreshLoading = false, 2000)
      try {
        const res = await this.$axios.cq9.refreshElectronicGameList()
        if (res.status === 1) {
          this.$Message.success('已更新');
          this.getElectronicGameList()
        }
        loadingTime()
      } catch (error) {
        console.log(error);
        loadingTime()
        this.$Message.error('网路异常');
      }
    },
    async modifySiteGameTrigger () {
      this.sortSateLoading = true
      const obj = {
        loid: this.getmember.pid,
        gameitme: this.modifyArray(this.items, (it) => ({ linkgameid: it.linkgameid, idop: it.idop }))
      }
      if (!obj.gameitme.length) return this.$Message.warning("请选择修改游戏"), this.sortSateLoading = false
      try {
        const res = await this.$axios.cq9.modifyElectronicGameList(obj)
        if (res.status === 1) {
          this.$Message.success("已更改");
          this.getElectronicGameList()
          this.sortSate = false;
        }
        this.sortSateLoading = false
      } catch (error) {
        console.log(error);
        this.sortSateLoading = false
        this.$Message.error('cq9修改游戏开关错误');
      }
    }
  }
};
</script>
<style>
.electronicSelect {
  margin-right: 10px;
  font-weight: bold;
}
table.TB_COLLAPSE tbody td.electronicTh {
  background-color: #e3ecec;
}
/* table.TB_COLLAPSE tbody td {
  font-weight: bold;
} */
.sateColor {
  margin: 0 auto;
  color: rgb(255, 255, 255);
  font-weight: bold;
  background: #ed4014;
  width: 60px;
  height: 20px;
  border-radius: 30px;
}
.sateColorClose {
  color: rgb(255, 255, 255);
  font-weight: bold;
  background: #ed4014;
  width: 40px;
  height: 20px;
  border-radius: 20px;
  float: right;
  margin-left: 4px;
}
.sateColorOpen {
  color: rgb(255, 255, 255);
  font-weight: bold;
  background: #19be6b;
  width: 40px;
  height: 20px;
  border-radius: 20px;
  float: right;
  margin-left: 4px;
}
.marginCtorlBox {
  margin-top: -10px;
  position: absolute;
  z-index: 999;
}
.marginSortBox .sortDiv {
  margin-top: 15px;
  position: absolute;
  z-index: 999;
}
.setBackBtn {
  margin-left: 10px;
}
</style>
